import React from 'react';
import { Select, MenuItem } from '@mui/material';

export default function SortBySelect({ sortBy, setSortBy }) {
  return (
    <div className="sort-by-container">
      <p className="sort-by-label">Sort By:</p>
      <Select className="styled-select" value={sortBy} onChange={(e) => setSortBy(e.target.value)}>
        <MenuItem value="Price Low to High">Price Low to High</MenuItem>
        <MenuItem value="Price High to Low">Price High to Low</MenuItem>
        <MenuItem value="Like New to Worn">Like New to Worn</MenuItem>
        <MenuItem value="Worn to Like New">Worn to Like New</MenuItem>
      </Select>
    </div>
  );
}